module.exports = new __parcel__URL__("template-roadmap-icon.873220f8.svg").toString();